<script setup lang="ts">
import { toRef } from 'vue';

import VForm from '@modules/forms/components/VForm/VForm.vue';
import { useRolesAndPermissionsTranslate } from '@modules/roles-and-permissions/composables';

import type { ICreateRoleEmits, ICreateRoleProps } from './types';
import { useCreateRole } from './composables';

const props = defineProps<ICreateRoleProps>();
const emit = defineEmits<ICreateRoleEmits>();

const { translate } = useRolesAndPermissionsTranslate();
const {
  errors,
  isRoleCreateLoading,
  formSchema,
  clearFormError,
  handleSubmit,
  handleChange,
} = useCreateRole(
  toRef(props, 'namespace'),
  emit,
);
</script>

<template>
  <VForm v-data-qa-auto-id="'VRoleCreate'"
    class="max-w-[450px]"
    :schema="formSchema"
    :submit-btn-label="translate('CREATE_ADD_ROLE')"
    :is-loading="isRoleCreateLoading"
    :custom-errors="errors"
    @change="handleChange"
    @submit="handleSubmit"
    @interacted="clearFormError"
  />
</template>
